import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import { round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { newRate } from '@tool/index';

const moFee = observable({
  type: 'chart', // chart, table
  empty: false,
  tableTitle: <any[]>[],
  tableList: <any[]>[],

  saleX: <any[]>[],
  saleY: <any[]>[],
  developX: <any[]>[],
  developY: <any[]>[],
  adminX: <any[]>[],
  adminY: <any[]>[],
  overview: <any[]>[],
});

const feeInit = action((res: any) => {
  // console.log('薪酬成本投入 - 费用中的薪酬占比 -- ', res);
  if (isEmpty(res)) {
    moFee.empty = true;
    return;
  }
  if (isEmpty(res?.admin) && isEmpty(res?.develop) && isEmpty(res?.sale)) {
    moFee.empty = true;
    return;
  }
  moFee.empty = false;
  const adminX: any[] = [];
  const adminY: any[] = [];
  const developX: any[] = [];
  const developY: any[] = [];
  const saleX: any[] = [];
  const saleY: any[] = [];
  const yearArr: any[] = [];
  const tableArr: any[] = [];

  res?.admin?.map((item: any) => {
    adminX.unshift(item.value);
    adminY.unshift(item.year);
    yearArr.push(item.year);
  });
  res?.develop?.map((item: any) => {
    developX.unshift(item.value);
    developY.unshift(item.year);
  });
  res?.sale?.map((item: any) => {
    saleX.unshift(item.value);
    saleY.unshift(item.year);
  });

  for (let i = 0; i < yearArr.length; i += 1) {
    tableArr.push([yearArr[i]]);
  }
  tableArr.map((item: any) => {
    res?.develop?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });
  tableArr.map((item: any) => {
    res?.sale?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });
  tableArr.map((item: any) => {
    res?.admin?.map((child: any) => {
      if (child.year === item[0]) {
        item.push(newRate(child.value));
      }
    });
  });

  runInAction(() => {
    moFee.adminX = adminX;
    moFee.adminY = adminY;
    moFee.developX = developX;
    moFee.developY = developY;
    moFee.saleX = saleX;
    moFee.saleY = saleY;
    moFee.tableList = tableArr;
    moFee.overview = res.overview;
    moFee.tableTitle = ['年份', '研发类薪酬/研发费用', '销售类薪酬/销售费用', '管理类薪酬/管理费用'];
  });
});

const changeType = action((value: string) => {
  moFee.type = value;
  localStorage.setItem('costFeeType', value);
});

export default moFee;
export {
  feeInit, changeType,
};
